import { getDataFromLocalStorage } from "../util/localStorage";
import { resolveRole } from "../util/accessControl";

const useAuth = () => {
  const userInfo = getDataFromLocalStorage("userInfo") || {};

  let role;
  if (Number(userInfo.org_id) === 1 && Number(userInfo.role) === 1) {
    role = "platform_admin";
  } else {
    role = userInfo.tenantRole || resolveRole(userInfo.role) || "viewer";
  }

  return {
    user: {
      ...userInfo,
      role,
      tenantId: userInfo.tenantId ? String(userInfo.tenantId) : null,
    },
  };
};

export default useAuth;
